/**************************************************************
-> Cookie banner logic
**************************************************************/
export function cookieBanner() {
  const cookieBanner = document.querySelector('.cookie-banner')
  const cookieBannerButtons = document.querySelectorAll('.cookie-banner button')

  if (localStorage.getItem('bannerShown') !== 'true') {
    cookieBanner.classList.remove('translate-y-full')
    cookieBanner.classList.add('translate-y-0')

    cookieBannerButtons.forEach(button => {
      button.addEventListener('click', () => {
        localStorage.setItem('bannerShown', 'true')
        cookieBanner.classList.remove('translate-y-0')
        cookieBanner.classList.add('translate-y-full')
      })
    })
  }
}


// WEBPACK FOOTER //
// ./scripts/components/cookie-banner.js